<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useListItem } from "@/hooks";
const { style } = useListItem();
</script>
<template>
  <MpPanel class="mp-list-panel" v-bind="$attrs" :extStyle="style">
    <slot />
  </MpPanel>
</template>
